module.exports = {
    "frames": [
        {
            "time": 0,
            "image": require("@frog/source/assets/images/bomber-tactics/units/blue/p-launch-blue/p-launch-blue1_.png").default
        },
        {
            "time": 100,
            "image": require("@frog/source/assets/images/bomber-tactics/units/blue/p-launch-blue/p-launch-blue2_.png").default
        },
        {
            "time": 200,
            "image": require("@frog/source/assets/images/bomber-tactics/units/blue/p-launch-blue/p-launch-blue3_.png").default
        },
        {
            "time": 300,
            "image": require("@frog/source/assets/images/bomber-tactics/units/blue/p-launch-blue/p-launch-blue4_.png").default
        },
        {
            "time": 400,
            "image": require("@frog/source/assets/images/bomber-tactics/units/blue/p-launch-blue/p-launch-blue5_.png").default
        },
        {
            "time": 500,
            "image": require("@frog/source/assets/images/bomber-tactics/units/blue/p-launch-blue/p-launch-blue6_.png").default
        },
        {
            "time": 600,
            "image": require("@frog/source/assets/images/bomber-tactics/units/blue/p-launch-blue/p-launch-blue7_.png").default,
            "duration": 50,
        },
        {
            "time": 650,
            "image": require("@frog/source/assets/images/bomber-tactics/units/blue/p-launch-blue/p-launch-blue8_.png").default
        },
        {
            "time": 750,
            "image": require("@frog/source/assets/images/bomber-tactics/units/blue/p-launch-blue/p-launch-blue9_.png").default
        },
        {
            "time": 850,
            "image": require("@frog/source/assets/images/bomber-tactics/units/blue/p-launch-blue/p-launch-blue10_.png").default
        },
        {
            "time": 950,
            "image": require("@frog/source/assets/images/bomber-tactics/units/blue/p-launch-blue/p-launch-blue11_.png").default
        },
        {
            "time": 1050,
            "image": require("@frog/source/assets/images/bomber-tactics/units/blue/p-launch-blue/p-launch-blue12_.png").default
        },
        {
            "time": 1150,
            "image": require("@frog/source/assets/images/bomber-tactics/units/blue/p-ready-blue/p-ready-blue1_.png").default
        }
    ]
}
